package org.example.zone360.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.icons.fa.FaStar
import com.varabyte.kobweb.silk.components.icons.fa.FaStarHalfStroke
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Strings
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.px

@Composable
fun StarRating(
    rating: Double,
    onRatingChanged: (Double) -> Unit,
    cursor: Boolean = false,
    color: Color? = null,
    size: CSSLengthOrPercentageValue = 15.px,
    gap: CSSLengthOrPercentageValue = 5.px,

) {
    Row(modifier = Modifier.gap(gap)) {
        for (i in 1..5) {
            val iconComposable: @Composable () -> Unit = when {
                i <= rating -> {
                    { FaStar(modifier = Modifier.color(Colors.Gold).cursor(if (cursor)Cursor.Pointer else Cursor.Default),style = IconStyle.FILLED) }
                }
                i - rating in 0.0..0.5 -> {
                    { FaStarHalfStroke(modifier = Modifier.color(Colors.Gold).cursor(if (cursor)Cursor.Pointer else Cursor.Default)) }
                }
                else -> {
                    { FaStar(modifier = Modifier.color(color ?: Colors.Gray).cursor(if (cursor)Cursor.Pointer else Cursor.Default)) }
                }
            }

            Box(
                modifier = Modifier
                    .size(size)
                    .onClick {
                        if (AppGlobal.userData.role == Strings.COACH) {
                            val clickedRating = when {
                                rating >= i -> i - 0.5
                                rating == i - 0.5 -> i.toDouble()
                                else -> i - 0.5
                            }
                            onRatingChanged(clickedRating)
                        }
                    }
            ) {
                iconComposable()
            }
        }
    }
}


